


































import Vue from 'vue';

export default Vue.extend({
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    hasContent: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    hovering: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    labelLeftOffset: {
      type: Number,
      default: 0,
    },
    large: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    labelInlineStyle(): object {
      return {
        marginLeft: this.labelLeftOffset
          ? `${this.labelLeftOffset}px`
          : undefined,
        marginTop: this.large ? '22px' : '12px',
      };
    },
    shouldMinimizeLabel(): boolean {
      return this.focused || this.hasContent;
    },
  },
});
